function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(80.784314%,47.45098%,45.882353%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 89.316406 14.830729 C 125.507812 14.830729 154.80957 44.160156 154.80957 80.351562 ",
    transform: "matrix(0.141176,0,0,0.141176,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,69.803922%,48.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 15.121745 89.644877 C 51.313151 89.644877 80.614909 118.974304 80.614909 155.16571 ",
    transform: "matrix(-0.141176,-0.000000000000000017,0.000000000000000017,-0.141176,13.517647,34.561997)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(32.54902%,25.882353%,96.862745%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 15.302216 14.833181 C 51.493622 14.833181 80.823049 44.162608 80.823049 80.354014 ",
    transform: "matrix(0.000000000000000009,-0.141176,0.141176,0.000000000000000009,0.0660601,13.504063)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(38.039216%,61.960784%,45.098039%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 89.367332 89.417157 C 125.558739 89.417157 154.888166 118.718915 154.888166 154.910322 ",
    transform: "matrix(0.000000000000000009,0.141176,-0.141176,0.000000000000000009,34.48688,0.00452917)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnm);
export default __webpack_public_path__ + "static/media/anm.98307a11.svg";
export { ForwardRef as ReactComponent };